import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'prepareRiskCategoryToList'
})
export class PrepareRiskCategoryToListPipe implements PipeTransform {

  transform(value: string | null | undefined): string[] {
    if (value) {
      return value.split(',');
    }

    return [];
  }

}
